// extracted by mini-css-extract-plugin
export default {"Screen-Overlay":"WebcamScreen_Screen-Overlay__y+zKp","muted-icon":"WebcamScreen_muted-icon__XGQrQ"};